var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M10.2655 7.41L8.85547 6L2.85547 12L8.85547 18L10.2655 16.59L5.68547 12L10.2655 7.41Z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M15.8556 7.41L17.2656 6L23.2656 12L17.2656 18L15.8556 16.59L20.4356 12L15.8556 7.41Z","key":1})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
